import { render, staticRenderFns } from "./SaleReviewPage.vue?vue&type=template&id=52614f06&scoped=true&"
import script from "./SaleReviewPage.vue?vue&type=script&lang=js&"
export * from "./SaleReviewPage.vue?vue&type=script&lang=js&"
import style0 from "./SaleReviewPage.vue?vue&type=style&index=0&id=52614f06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52614f06",
  null
  
)

export default component.exports